/* Sui Story — orchestrator.
   Runs once on load and re-runs page-scoped init after each Barba swap.
   Init order honours CLAUDE.md: Lenis -> GSAP/ScrollTrigger -> page transitions. */
(function () {
  var S = (window.SuiStory = window.SuiStory || {});

  // Re-runnable per container (document on first load, Barba container after swaps).
  S.initPage = function (scope) {
    scope = scope || document;
    if (S.initAnimations) S.initAnimations(scope);
    document.dispatchEvent(new CustomEvent('suistory:page:init', { detail: { scope: scope } }));
  };

  function boot() {
    if (window.gsap && window.ScrollTrigger) {
      try { gsap.registerPlugin(ScrollTrigger); } catch (e) {}
    }
    if (S.initLenis) S.initLenis();      // before any ScrollTrigger work
    S.initPage(document);
    if (S.initPageTransitions) S.initPageTransitions();
    // Triggers are first measured at DOMContentLoaded — before images/fonts load.
    // As the layout settles it shifts, leaving below-fold reveals + the 3D headline
    // stuck behind stale trigger positions. Re-measure once everything has loaded.
    var stRefresh = function () { if (window.ScrollTrigger) { try { ScrollTrigger.refresh(true); } catch (e) {} } };
    window.addEventListener('load', stRefresh);
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) document.fonts.ready.then(stRefresh);
    setTimeout(stRefresh, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
